export const LOGOUT_REASON_KEY = "fido_logout_reason";
export const LOGOUT_REASON_MANUAL = "manual";

export const setLogoutReason = (reason: string) => {
  try {
    sessionStorage.setItem(LOGOUT_REASON_KEY, reason);
  } catch {
    // noop - storage may be unavailable (privacy mode)
  }
};

export const consumeLogoutReason = () => {
  try {
    const reason = sessionStorage.getItem(LOGOUT_REASON_KEY);
    sessionStorage.removeItem(LOGOUT_REASON_KEY);
    return reason;
  } catch {
    return null;
  }
};
